import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import type User from 'flarum/common/models/User';
import currencySymbol from './currencySymbol';

export default function () {
  Discussion.prototype.bountiesEnabled = Model.attribute<boolean>('blomstra.bounties.enabled');
  Discussion.prototype.canEnableBounties = Model.attribute<boolean>('blomstra.bounties.can_enable');
  Discussion.prototype.backers = Model.hasMany<User>('backers');
  Discussion.prototype.totalBounty = Model.attribute<number>('blomstra.total_bounty');
  Discussion.prototype.bountyCurrencySymbol = function () {
    return currencySymbol(Model.attribute<string>('blomstra.bounty_currency').call(this));
  };

  Discussion.prototype.blomstraPtvPaid = Model.attribute<boolean>('blomstra.ptv.paid');
  Discussion.prototype.blomstraPtpPaid = Model.attribute<boolean>('blomstra.ptp.paid');
}
